<!--
 * @Author: DY
 * @Date: 2025-02-17 17:58:48
 * @LastEditTime: 2025-04-29 13:45:21
 * @Description: 附属产品入库【仓储管理】
 * @FilePath: \ShiMo_Mobile\src\views\storage\accessoriesWarehousing\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="accessoriesWarehousing commonListStyles">
            <van-nav-bar left-arrow left-text="应用" :style="`height: ${ $getNavHeight() }px;`" @click-left="swiperright">
                <template #title>
                    <div :class="{'active': listType == '0'}" @click="listSwitch('0')">
                        未入库
                    </div>
                    <div :class="{'active': listType == '1'}" @click="listSwitch('1')">
                        已入库
                    </div>
                </template>
                <template #right>
                    <span class="iconfont sm-shaixuan11" @click="rightClickFun"></span>
                </template>
            </van-nav-bar>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" :immediate-check="false" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">入库单号：{{ item.instock_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_13@2x.png" alt="">
                                            <span>入库类型：{{ item.instock_type_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.stock_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.material_short_names }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_44@2x.png" alt="">
                                            <span>入库总重量（吨）：{{ item.total_instock_count }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>入库时间：{{ item.instock_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>入库人：{{ item.instock_user_name }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.status == 0">
                                            <van-button plain type="danger" @click="toDetail(item, 'edit')">
                                                编辑
                                            </van-button>
                                            <van-button plain type="danger" @click="deleteInventory(item, index)">
                                                删除
                                            </van-button>
                                        </template>
                                        <template v-else>
                                            <van-button plain type="danger" @click="toDetail(item, 'see')">
                                                查看
                                            </van-button>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
                <button class="addBtn iconfont sm-icon-test" @click="toDetail(null, 'new')"></button>
            </section>
            <van-popup class="sideslip" v-model="popupShow" position="right" :style="{ width: '80%',height: '100%' }">
                <div class="screen">
                    <van-nav-bar title="筛选" right-text="取消" :style="`height: ${ $getNavHeight() }px;`" @click-right="popupShow = false"></van-nav-bar>
                    <section>
                        <dl>
                            <dt>入库单号</dt>
                            <dd>
                                <van-field v-model="params.instock_number" placeholder="输入入库单号"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>入库类型</dt>
                            <dd class="selectList">
                                <p
                                    v-for="(item, index) in instockType"
                                    :key="`instockType_${index}`"
                                    :class="{'active': item.value === params.instock_type}"
                                    @click="params.instock_type = item.value"
                                >
                                    {{ item.name }}
                                </p>
                            </dd>
                        </dl>
                        <dl>
                            <dt>入库时间</dt>
                            <dd>
                                <van-field
                                    readonly
                                    v-model="params.deliveryTime"
                                    placeholder="选择入库时间"
                                    @click="calendarShow = true"
                                ></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>入库人</dt>
                            <dd>
                                <van-field v-model="params.instock_user_name" placeholder="输入入库人"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>入库部门</dt>
                            <dd class="selectList">
                                <p
                                    v-for="(item, index) in instockDeptList"
                                    :key="`instockDept_${index}`"
                                    :class="{'active': item.Code === params.instock_dept_id}"
                                    @click="params.instock_dept_id = item.Code"
                                >
                                    {{ item.Name }}
                                </p>
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="search">
                            确定
                        </button>
                        <button @click="resetSelect">
                            重置
                        </button>
                    </footer>
                </div>
            </van-popup>
            <van-calendar
                type="range"
                v-model="calendarShow"
                :min-date="minDate"
                :default-date="defaultDate"
                @confirm="onConfirmCalendar"
            ></van-calendar>
        </div>
    </v-touch>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'accessories-warehousing',
    mixins: [mixin_list],
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'accessories-warehousing');
        }
        next();
    },
    data() {
        return {
            listType: '0',
            instockType: [{
                name: '全部',
                value: '',
            }, {
                name: '生产入库',
                value: '0',
            }, {
                name: '短运入库',
                value: '1',
            }, {
                name: '混料领用入库',
                value: '2',
            }, {
                name: '混料加工入库',
                value: '3',
            }, {
                name: '返厂入库',
                value: '4',
            }, {
                name: '外购成品入库',
                value: '5"',
            }, {
                name: '销售退货入库',
                value: '6"',
            }],
            instockDeptList: [],
            params: {
                instock_number: '',
                instock_time_max: '',
                instock_time_min: '',
                instock_type: '',
                deliveryTime: '',
                instock_user_name: '',
                instock_dept_id: '',
            },
            calendarShow: false,
            defaultDate: [],
            minDate: new Date(2000, 0, 1),
            tableCode: 'instock_ccp',
            popupShow: false,
            requestData: {},
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    async created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
        this.instockDeptList = await this.getInstockDeptListRequest();
        this.instockDeptList.unshift({ Name: '全部', Code: '' });
        this.params.instock_dept_id = this.$takeTokenParameters('DeptId');
        // this.params.instock_dept_id = this.instockDeptList[1].Code;
        this.initPage();
    },
    mounted() {},
    computed: {},
    methods: {
        listSwitch(type) {
            this.listType = type;
            this.search();
        },
        formatDate(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        onConfirmCalendar(date) {
            const [start, end] = date;
            this.calendarShow = false;
            this.params.instock_time_min = this.formatDate(start);
            this.params.instock_time_max = this.formatDate(end);
            this.params.deliveryTime = `${this.params.instock_time_min} ~ ${this.params.instock_time_max}`;
        },
        loadRequestData() {
            return {
                code: this.tableCode,
                cacheKey: this.cacheKey,
                page: this.pageIndex,
                limit: this.pageSize,
                instock_type: this.params.instock_type,
                instock_time_min: this.params.instock_time_min !== '' ? currencyFun.timeFormat(new Date(this.params.instock_time_min), 'yyyy-MM-dd HH:mm:ss') : '',
                instock_time_max: this.params.instock_time_max !== '' ? currencyFun.timeFormat(new Date(this.params.instock_time_max), 'yyyy-MM-dd HH:mm:ss') : '',
                instock_number: this.params.instock_number,
                instock_user_name: this.params.instock_user_name,
                instock_dept_id: this.params.instock_dept_id,
                status: this.listType,
                product_category: 1,
            };
        },
        // 确认筛选
        search() {
            this.listData = [];
            this.pageIndex = 0;
            this.finished = false;
            this.popupShow = false;
            this.initPage();
        },
        // 重置筛选条件
        resetSelect() {
            this.defaultDate = [];
            this.params.instock_type = '';
            this.params.deliveryTime = '';
            this.params.instock_time_min = '';
            this.params.instock_time_max = '';
            this.params.instock_number = '';
            this.params.instock_user_name = '';
            this.params.instock_dept_id = '';
        },
        rightClickFun() {
            this.popupShow = true;
        },
        toDetail(item, type) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'accessoriesWarehousingForm',
                params: {
                    type,
                    id: item?.id || '',
                },
            });
        },
        // 删除入库单
        deleteInventory(item, index) {
            this.$dialog.confirm({
                message: `确认删除入库单 \n${item.instock_number} ？`,
            }).then(async () => {
                const res = this.deleteInventoryRequest(item.id);
                if (res) {
                    this.$toast.success('删除成功');
                    this.listData.splice(index, 1);
                }
            });
        },
        deleteInventoryRequest(id) {
            return this.$axios.$get(`/interfaceApi/sale/instock_ccp/delete?id=${id}`);
        },

        // 获取入库部门
        getInstockDeptListRequest() {
            return this.$axios.$get('interfaceApi/sale/tenantcode/getbytype/warehouse_dept');
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.accessoriesWarehousing
    width 100%
    height 100%
    background #F0F0F0
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    .sideslip
        section
            dl
                dd
                    p
                        width 48%
</style>
